<template>
  <div
    :style="{
      'background-image': 'url(' + banner.image.source + ')',
    }"
    :class="[
      'banner',
      { 'banner--right': banner.content_position === 'right' },
    ]"
  >
    <div :style="{ color: banner.text_color }" class="banner__content">
      <div
        v-if="banner.title"
        class="banner__title h3"
        v-html="banner.title"
      ></div>
      <div
        v-if="banner.description"
        class="banner__description"
        v-html="banner.description"
      ></div>
      <div class="banner__btn">
        <button
          type="button"
          class="btn btn-white btn-small stretched-link"
          data-popup-with-chats
          :data-popup-with-chats-title="
            banner.text_button || 'Узнать подробнее'
          "
          @click="$emit('click', $event, banner)"
        >
          {{ banner.text_button || "Узнать подробнее" }}
        </button>
      </div>
      <div
        v-if="banner.agreement_text"
        class="banner__footnote"
        v-html="banner.agreement_text"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    banner: {
      type: Object,
      required: true,
    },
  },
  emits: ["click"],
};
</script>

<style scoped>
.banner {
  position: relative;
  padding: 0;
  background-position: 0 50%;
  background-size: cover;
  background-repeat: no-repeat;
}

.banner--right {
  text-align: right;
}

.banner__content {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 224px;
  padding: 35px 40px 40px 39%;
  color: #fff;
  font-weight: 300;
}

.banner__title {
  margin-bottom: 12px;
  font-size: 36px;
  letter-spacing: -0.03em;
}

.banner__title:last-child {
  margin-bottom: 0;
}

.banner__description {
  margin-bottom: 42px;
  line-height: 1.5;
}

.banner__footnote {
  font-size: 11px;
  line-height: 1.2;
  opacity: 0.6;
}

@media (max-width: 1279px) {
  .banner__title {
    font-size: 32px;
  }
}
@media (min-width: 992px) {
  .banner__title {
    line-height: 1.1;
  }
}

.banner__btn {
  margin-bottom: 12px;
}
@media (max-width: 991px) {
  .banner::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(0 0 0 / 0.25);
  }

  .banner__title {
    font-size: 26px;
  }
}
@media (max-width: 767px) {
  .banner__btn .btn {
    padding: 10px 20px 12px;
    font-size: 16px;
  }
}
@media (max-width: 575px) {
  .banner {
    background-position: 100% 50%;
    background-size: auto 2000px;
  }

  .banner::before {
    display: none;
  }

  .banner__content {
    padding: 30px;
  }

  .banner__title {
    font-size: 24px;
  }
}
</style>
